(function() {
  document.querySelectorAll('[data-ferrier-hero]').forEach(function(hero) {
    var slides = hero.querySelectorAll('.ferrier-hero__slide');
    var dots = hero.querySelectorAll('.ferrier-hero__dot');
    var prevBtn = hero.querySelector('[data-hero-prev]');
    var nextBtn = hero.querySelector('[data-hero-next]');
    if (slides.length < 2) return;

    var current = 0;
    var timer = null;
    var autoplay = hero.dataset.autoplay === 'true';
    var speed = (parseInt(hero.dataset.speed, 10) || 6) * 1000;

    function goTo(idx) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
      reset();
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function reset() {
      if (timer) clearInterval(timer);
      if (autoplay) timer = setInterval(next, speed);
    }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);
    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() { goTo(i); });
    });

    reset();
  });
})();